import React from 'react';
import { bool, shape, string } from 'prop-types';

const HistoryColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.375 9C3.375 5.2725 6.3975 2.25 10.125 2.25C13.8525 2.25 16.875 5.2725 16.875 9C16.875 12.7275 13.8525 15.75 10.125 15.75C8.2575 15.75 6.5775 14.9925 5.355 13.77L6.42 12.705C7.365 13.6575 8.6775 14.25 10.125 14.25C13.0275 14.25 15.375 11.9025 15.375 9C15.375 6.0975 13.0275 3.75 10.125 3.75C7.2225 3.75 4.875 6.0975 4.875 9H7.125L4.095 12.0225L4.0425 11.9175L1.125 9H3.375ZM9.375 9.75V6H10.5V9.1125L13.14 10.68L12.5625 11.64L9.375 9.75Z" fill="currentColor" />
  </svg>
);

HistoryColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default HistoryColor;
